import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { dashboard_template } from "../components/templates/dashboard_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";

declare var ko: any;
declare var page: any;

let chartDiv;

export class dashboard extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected dashboardTemplate: dashboard_template;
    protected viewPageUrl;
    protected destroyed: boolean = false;

    protected getModuleName() {

        return "dashboard";
    }

    buildContent(): Array<Element> {

        // create validation errors list template
        this.dashboardTemplate = new dashboard_template("list", this.viewModel, this);
        this.template = this.dashboardTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;

        if (this.getVnAppZone().app.params.idBrand) {
            (<header>loadedModule).setHeaderTitle("Live Dashboard");
        } else {
            (<header>loadedModule).setHeaderTitle("Network Live Dashboard");
        }

        return [this.dashboardTemplate.build()];
    }

    public fillPage(): void {

        this.updateViewModelFromPath();

        this.getDataViews();
        this.getDataTrends();
        this.getDataAccounts();
        this.getDataSegments();
        this.getDataSubscriptions();
        this.dashboardTemplate.loadPage();
        this.loadingOut(this.dashboardTemplate.builtTemplate);
    }


    public autoRefresh() {
        if (this.destroyed) {
            return;
        }

        this.getDataSubscriptions();
        this.getDataViews();
        this.getDataAccounts();
        this.getDataTrends();
        this.getDataSegments();
    }

    public cleanup(): void {
        this.destroy();
    }

    protected destroy(): void {
        // Clean up resources
        chartDiv = null;
        this.viewPageUrl = null;
        this.dashboardTemplate = null;
        this.viewModel = null;
        this.destroyed = true;
    }

    protected getData() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataSubscriptions() {
        chartDiv = document.getElementById("dashboard");
        let usrReq_url: string = '/api/dashboard/get/subscriptions/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/subscriptions/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataViews() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/views/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/views/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataTrends() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/trends/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/trends/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataSegments() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/segments/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/segments/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataAccounts() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/accounts/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/accounts/';
        }
        let subViewModel = this.dashboardTemplate.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }


    protected onGetData(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {

                let responseParsed = JSON.parse(req.request.response, function (key, value) {
                    if (key == "date" || key == "publishDate" || key == "republishDate") {
                        return new Date(value);
                    } else {
                        return value;
                    }
                });
                obj.dashboardTemplate.setResults(responseParsed);
            });

            if (obj.getChartDiv()) {
                obj.loadingOut(obj.getChartDiv());
            } else {
                obj.loadingOut(obj.dashboardTemplate.builtTemplate);
            }
        }
    }

    public getChartDiv() {
        return chartDiv;
    }

    protected viewArticle(id, idBrand) {

        if (this.getVnAppZone().app.params.idBrand) {
            idBrand = this.getVnAppZone().app.params.idBrand;
        }
        this.viewPageUrl = '/brand/' + idBrand + '/articles/view/' + id;
        window.open(this.viewPageUrl, "_blank");
    }

    public filterAutoRefreshStatusOnChange() {
        if (this.destroyed) {
            return;
        }
        
        this.getDataSubscriptions();
        this.getDataViews();
        this.getDataTrends();
        this.getDataAccounts();
        this.getDataSegments();
    }
}


// WEBPACK FOOTER //
// ./js/modules/dashboard.ts